var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "book-component-list-folder" }, [
    _c(
      "div",
      {
        staticClass: "book-component-list-folder__header",
        on: {
          click: function($event) {
            _vm.folder.toggle()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "book-component-list-folder__header__caret" },
          [
            _vm.folder.isOpen
              ? _c("font-awesome-icon", {
                  attrs: { icon: _vm.icons.faCaretDown }
                })
              : _c("font-awesome-icon", {
                  attrs: { icon: _vm.icons.faCaretRight }
                })
          ],
          1
        ),
        _vm._v(" "),
        _c("font-awesome-icon", {
          staticClass: "book-component-list-folder__header__icon",
          attrs: { icon: _vm.icons.faFolder }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "book-component-list-folder__title" }, [
          _c("span", [_vm._v(_vm._s(_vm.folder.name))])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.folder.isOpen && !_vm.folder.isEmpty()
      ? _c(
          "div",
          { staticClass: "book-component-list-folder__insides" },
          [
            _vm._l(_vm.folder.folders, function(child) {
              return _c("book-component-list-folder", {
                key: _vm.generateKey(),
                ref: "folders",
                refInFor: true,
                attrs: { folder: child }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.folder.files, function(file) {
              return _c("vm-file", {
                key: _vm.generateKey(),
                attrs: { file: file }
              })
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }